import { Component } from '@angular/core';

@Component({
  selector: 'ctx-context-menu',
  template: `
`,
  styles: [``]
})
export class ContextMenuDeprecatedComponent {
  constructor() {
    console.warn('[Contexr] Adding <ctx-context-menu> to your page is deprecated! From version' +
      ' 3.0.0 this will break your context menu!');
  }
}
